/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * @author Satyaki Bose
 * @file SettingsSelectMenuItem.jsx
 */

import React from 'react';
import { MenuItem } from '@mui/material';
import Icon from '../../icons/Icon';

function renderMenuItemCheckIcon({ selected, showSelectedCheckIcon, classes }) {
  if (!showSelectedCheckIcon) {
    return null;
  }

  if (selected) {
    return <Icon name="TickIcon" className={classes.menuItemCheckIcon} />;
  }

  return (
    <span
      className={`${classes.menuItemCheckIcon} ${classes.menuItemCheckIconPlaceholder}`}
      aria-hidden
    />
  );
}

export function renderSettingsSelectMenuItem({
  option,
  selectedValue,
  classes,
  menuItemProps = {},
  showSelectedCheckIcon = true
}) {
  const selected = option.value === selectedValue;
  const itemClassName = selected
    ? `${classes.menuItem} ${classes.menuItemSelected}`
    : classes.menuItem;

  return (
    <MenuItem
      key={option.value}
      {...menuItemProps}
      value={option.value}
      className={itemClassName}
    >
      <span className={classes.menuItemLabel}>{option.label}</span>
      {renderMenuItemCheckIcon({ selected, showSelectedCheckIcon, classes })}
    </MenuItem>
  );
}

export default renderSettingsSelectMenuItem;
